import logo_gruf from "url:$assets/logos/logo_gruf.svg";
import logo_versembrant_blanc from "$assets/logos/logo_versembrant_blanc.svg";
import logo_gene_blanc from "$assets/logos/logo_gene_blanc.svg";
import { useState } from "react";
import { goToGruf } from "../utils/misc";
import { ArrowLeftIcon } from "lucide-react";
ArrowLeftIcon


export const ProjectLikeFrame = ({content}) => {
    return (
        <div className="project-wrapper">
            <div className="project">
                <div className="header text-14">
                    <div><img src={logo_gruf} className="logo_gruf"/></div>
                    <a className="btn-petit no-border" href={appPrefix + "/"}><ArrowLeftIcon /></a>
                </div>
                { content }
            </div>
        </div>
    )
}

export const Connect = ({infoProjects}) => {
    const connectError = document.getElementById('root').dataset.connectError === "True";
    
    const [grufId, setGrufId] = useState("");
    return <ProjectLikeFrame content={
        <div className="connectat">
            {connectError && <p className="connect-error">Oh no! Aquest Gruf no existeix! :(</p>}
            <div>
                <h1>ID del GRUF: <input type="text" autoFocus value={grufId} onChange={e => setGrufId(e.target.value)} onKeyUp={e => {if (e.key === "Enter") goToGruf(grufId)}}></input></h1>
                <ul>
                    <li><a href={appPrefix + "/nou_projecte"} className="btn btn-gran btn-black">Crea un nou GRUF</a></li>
                    <li><button id="connectaButton" className="btn btn-gran btn-black--primary"
                        onClick={() => goToGruf(grufId)}
                        // TODO: do a check on connecta to see if the project is actually available before trying to go
                    >Connecta't al GRUF</button></li>
                </ul>
            </div>
        </div>
    }/>
};
